import { useState } from 'react'

interface UseStepperOptions {
  initialStep?: number
  steps: number
}

export const useStepper = ({ initialStep = 0, steps }: UseStepperOptions) => {
  const [history, setHistory] = useState<number[]>([initialStep])

  const currentStep = history[history.length - 1]
  const priorStep = history.length > 1 ? history[history.length - 2] : initialStep

  const next = () => {
    setHistory((h) => [...h, Math.min(currentStep + 1, steps - 1)])
  }

  const prev = () => {
    setHistory((h) => (h.length > 1 ? h.slice(0, -1) : h))
  }

  const goToStep = (step: number) => {
    setHistory((h) => [...h, Math.max(0, Math.min(step, steps - 1))])
  }

  return {
    currentStep,
    priorStep,
    next,
    prev,
    goToStep,
    isFirstStep: history.length === 1,
    isLastStep: currentStep === steps - 1
  }
}
